import React,{useEffect,useState} from "react"
import {Form,Col,Row} from 'react-bootstrap'

function Samples(props) {
    const handleChange = (event) => {
      props.handler(props.sampleName, event);
    };
  
    const selectDisabled = props.edit;
    const dateDisabled = props.edit || props.data[props.name] !== "Yes";
  
    return (
      <Form>
        <Row>
          <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control
              as={"select"}
              value={props.data[props.name]}
              name={props.name}
              disabled={selectDisabled}
              onChange={handleChange}
            >
              <option></option>
              <option>Yes</option>
              <option>No</option>
            </Form.Control>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Date</Form.Label>
            <Form.Control
              name={props.name + "_date"}
              type={"date"}
              onChange={(e) => {
                props.handler(props.sampleName, e);
              }}
              value={props.data[props.name + "_date"]}
              disabled={dateDisabled}
            />
          </Form.Group>
        </Row>
      </Form>
    );
  }
  

export default Samples